var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ApiClient_accessToken, _ApiClient_client;
import axios from 'axios';
import { SdkError, handleError } from './error';
import config from './config';
// import type { Agent as HttpAgent } from 'http'
// import type { Agent as HttpsAgent } from 'https'
// import { packageInfo } from './util'
import Debug from './debug';
const debug = Debug('client');
const baseURL = (organization, domain) => {
    return `https://${organization.toLowerCase()}.${domain || config.default.domain}/api`;
};
class ApiClient {
    static create(options) {
        for (const attr of config.client.requiredAttributes)
            if (!options || !options[attr])
                throw new SdkError({ message: `Undefined '${attr}' parameter` });
        return new ApiClient(options);
    }
    constructor(options) {
        _ApiClient_accessToken.set(this, void 0);
        _ApiClient_client.set(this, void 0);
        debug('new client instance %O', options);
        this.baseUrl = baseURL(options.organization, options.domain);
        __classPrivateFieldSet(this, _ApiClient_accessToken, options.accessToken, "f");
        const axiosConfig = {
            timeout: options.timeout || config.client.timeout,
            proxy: options.proxy,
            httpAgent: options.httpAgent,
            httpsAgent: options.httpsAgent
        };
        // Set custom headers
        const customHeaders = this.customHeaders(options.headers);
        // Set headers
        const headers = {
            ...customHeaders,
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            'Authorization': 'Bearer ' + __classPrivateFieldGet(this, _ApiClient_accessToken, "f")
        };
        // Set User-Agent
        let userAgent = options.userAgent; // || `SDK-core axios/${axios.VERSION}`
        if (userAgent) {
            if (!userAgent.includes('axios/'))
                userAgent += ` axios/${axios.VERSION}`;
            headers['User-Agent'] = userAgent;
        }
        const axiosOptions = {
            baseURL: this.baseUrl,
            timeout: config.client.timeout,
            headers,
            ...axiosConfig
        };
        if (options.adapter)
            axiosOptions.adapter = options.adapter;
        debug('axios options: %O', axiosOptions);
        __classPrivateFieldSet(this, _ApiClient_client, axios.create(axiosOptions), "f");
        this.interceptors = __classPrivateFieldGet(this, _ApiClient_client, "f").interceptors;
    }
    config(config) {
        debug('config %o', config);
        const def = __classPrivateFieldGet(this, _ApiClient_client, "f").defaults;
        // Axios config
        if (config.timeout)
            def.timeout = config.timeout;
        if (config.proxy)
            def.proxy = config.proxy;
        if (config.httpAgent)
            def.httpAgent = config.httpAgent;
        if (config.httpsAgent)
            def.httpsAgent = config.httpsAgent;
        if (config.adapter)
            this.adapter(config.adapter);
        if (config.userAgent)
            this.userAgent(config.userAgent);
        // API Client config
        if (config.organization)
            this.baseUrl = baseURL(config.organization, config.domain);
        if (config.accessToken) {
            __classPrivateFieldSet(this, _ApiClient_accessToken, config.accessToken, "f");
            def.headers.common.Authorization = 'Bearer ' + __classPrivateFieldGet(this, _ApiClient_accessToken, "f");
        }
        if (config.headers)
            def.headers.common = this.customHeaders(config.headers);
        return this;
    }
    userAgent(userAgent) {
        if (userAgent) {
            let ua = userAgent;
            if (!ua.includes('axios/')) {
                // const axiosVer = packageInfo(['dependencies.axios'], { nestedName: true })
                if (axios.VERSION)
                    ua += ` axios/${axios.VERSION}`;
            }
            __classPrivateFieldGet(this, _ApiClient_client, "f").defaults.headers['User-Agent'] = ua;
        }
        return this;
    }
    adapter(adapter) {
        if (adapter)
            __classPrivateFieldGet(this, _ApiClient_client, "f").defaults.adapter = adapter;
        return this;
    }
    async request(method, path, body, options) {
        debug('request %s %s, %O, %O', method, path, body || {}, options || {});
        // Ignored params alerts (in debug mode)
        if (options === null || options === void 0 ? void 0 : options.adapter)
            debug('Adapter ignored in request config');
        if (options === null || options === void 0 ? void 0 : options.userAgent)
            debug('User-Agent header ignored in request config');
        const data = body ? { data: body } : undefined;
        const url = path;
        // Runtime request parameters
        const baseUrl = (options === null || options === void 0 ? void 0 : options.organization) ? baseURL(options.organization, options.domain) : undefined;
        const accessToken = (options === null || options === void 0 ? void 0 : options.accessToken) || __classPrivateFieldGet(this, _ApiClient_accessToken, "f");
        const headers = this.customHeaders(options === null || options === void 0 ? void 0 : options.headers);
        if (accessToken)
            headers.Authorization = 'Bearer ' + accessToken;
        const requestParams = { method, baseURL: baseUrl, url, data, ...options, headers };
        debug('request params: %O', requestParams);
        // const start = Date.now()
        return __classPrivateFieldGet(this, _ApiClient_client, "f").request(requestParams)
            .then(response => response.data)
            .catch((error) => handleError(error));
        // .finally(() => console.log(`<<-- ${method} ${path} ${Date.now() - start}`))
    }
    customHeaders(headers) {
        const customHeaders = {};
        if (headers) {
            for (const [name, value] of Object.entries(headers))
                if (!['accept', 'content-type', 'authorization', 'user-agent'].includes(name.toLowerCase()))
                    customHeaders[name] = value;
        }
        return customHeaders;
    }
}
_ApiClient_accessToken = new WeakMap(), _ApiClient_client = new WeakMap();
export default ApiClient;
